import React, { useCallback } from 'react'

import WorkShiftsInputButton from './WorkShiftsInputButton'
import { useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import { validateWorkShifts } from '../../../modules/users/editV2/_requests/saveUser'
import WorkShiftsModal from './WorkShiftsModal'

const WorkShiftsInput = ({ disabled, onChange, value, useRange, useTime, ...props }) => {
  const { form, setErrors } = useFormState()
  const [open, setOpen] = React.useState(false)
  const onClose = () => setOpen(false)

  const validate = useCallback(() => {
    const errors = validateWorkShifts(form, false)
    if (!errors.length) {
      setOpen(false)
    }
    setErrors(errors)
  }, [form, setErrors])

  return (
    <>
      <WorkShiftsInputButton onClick={() => setOpen(!open)} />

      <WorkShiftsModal validate={validate} open={open} onClose={onClose} path={['contract', 'workShifts']} />
    </>
  )
}

export default WorkShiftsInput
